import React, { useState } from "react";
import "./DonatePage.css";

function DonatePage() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    type: "",
    company: "",
    amount: "",
    cause: [],
  });

 const handleChange = (e) => {
  const { name, value } = e.target;

  // Allow only numbers in amount field
  if (name === "amount" && !/^\d*$/.test(value)) return;

  setForm((prev) => ({
    ...prev,
    [name]: value,
    ...(name === "type" && value !== "Corporate"
      ? { company: "" }
      : {}),
  }));
};


 const handleCauseClick = (cause) => {
  setForm((prev) => {
    const alreadySelected = prev.cause.includes(cause);

    return {
      ...prev,
      cause: alreadySelected
        ? prev.cause.filter((c) => c !== cause) // remove
        : [...prev.cause, cause] // add
    };
  });
};

//Submit button
const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation
  if (
    !form.firstName ||
    !form.lastName ||
    !form.type ||
    //!form.company ||
    !form.amount ||
    form.cause.length === 0
  ) {
    alert("Please fill all fields");
    return;
  }

  // Company mandatory only for Corporate
if (form.type === "Corporate" && !form.company.trim()) {
  alert("Company Name is required for Corporate");
  return;
}

  // Minimum amount validation
  if (Number(form.amount) < 500) {
    alert("Minimum amount should be ₹500");
    return;
  }

  try {

    const response = await fetch(
      "http://localhost:5000/api/send-email",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
  firstName: form.firstName,
  lastName: form.lastName,
  type: form.type,
  company: form.company,
  amount: form.amount,
  cause: form.cause,
}),
      }
    );

    const data = await response.json();

    if (data.success) {

      alert("Email sent successfully");

      // Reset form
      setForm({
        firstName: "",
        lastName: "",
        type: "",
        company: "",
        amount: "",
        cause: [],
      });

    } else {

      alert("Failed to send email");
    }

  } catch (error) {

    console.error(error);

    alert("Server error");
  }
};

  return (
    <div className="donatepage">
      <div className="modal-header">
        <h2>Support Us</h2>
        <p>Interested in supporting our cause? Get in touch!</p>
      </div>

     {/*<div className="modal-body">*/} 
     <form className="modal-body" onSubmit={handleSubmit}>
        <div className="row">
          <div className="field">
            <label>First Name 
              <span className="required">*</span>
            </label>
            <input name="firstName" value={form.firstName} onChange={handleChange} />
          </div>

          <div className="field">
            <label>Last Name 
              <span className="required">*</span>
            </label>
            <input name="lastName" value={form.lastName} onChange={handleChange} />
          </div>
        </div>

        <div className="label">Select Yourself 
          <span className="required">*</span>
        </div>

        <div className="radio-group">
          <label>
            <input type="radio" name="type" value="Individual" checked={form.type === "Individual"} onChange={handleChange} />
            Individual
          </label>

          <label>
            <input type="radio" name="type" value="Corporate" checked={form.type === "Corporate"} onChange={handleChange} />
            Corporate
          </label>

          <label>
            <input type="radio" name="type" value="Other" checked={form.type === "Other"} onChange={handleChange} />
            Other
          </label>
        </div>

        <div className="row">
          <div className="field">
            <label>Company Name 
               {form.type === "Corporate" && (
              <span className="required">*</span>
              )}
            </label>
            <input name="company" value={form.company} onChange={handleChange} 
             disabled={form.type !== "Corporate"}
             required={form.type === "Corporate"}
             placeholder={
             form.type === "Corporate"
             ? "Enter company name"
             : "Not required"
             }
             />
          </div>

          <div className="field">
            <label>Amount 
              <span className="required">*</span>
            </label>
            <input name="amount" type="text" onChange={handleChange}  value={form.amount}
            placeholder="Enter amount"/>
            {form.amount && Number(form.amount) < 500 && (
            <p style={{ color: "red" }}>
            Minimum amount should be ₹500
            </p>
            )}
            
          </div>
        </div>

        <div className="causes-grid">

  <div className="field">
  <label>Select Cause 
    <span className="required">*</span>
  </label>

  <div className="causes-grid">

    <div
      className={`cause-card ${form.cause.includes("Environmental Sustainability") ? "active" : ""}`}
      onClick={() => handleCauseClick("Environmental Sustainability")}
    >
      🌱 Environmental Sustainability
    </div>

    <div
      className={`cause-card ${form.cause.includes("Education & Child Development") ? "active" : ""}`}
      onClick={() => handleCauseClick("Education & Child Development")}
    >
      📚 Education & Child Development
    </div>

    <div
      className={`cause-card ${form.cause.includes("Skill Development & Youth Empowerment") ? "active" : ""}`}
      onClick={() => handleCauseClick("Skill Development & Youth Empowerment")}
    >
      🧑‍💼 Skill Development & Youth Empowerment
    </div>

    <div
      className={`cause-card ${form.cause.includes("Community Development") ? "active" : ""}`}
      onClick={() => handleCauseClick("Community Development")}
    >
      🏘 Community Development
    </div>

  </div>

  {/* Optional display 
  <p>Selected: {form.cause.join(", ")}</p>
  <p>Selected: {form.cause.length > 0 ? form.cause.join(", ") : "None"}</p>*/}
</div>
        </div>

        <button type="submit" className="submit-btn">Submit Request</button>
        </form>
        
      </div>
      
   
  );
}

export default DonatePage;